module.exports = __webpack_public_path__ + "img/l200_power.8ab04458.jpg";